import { ViewColumnState } from "../../../../../application-controller/store/states/view-col.states";

export interface ViewCacheState {
  branchSettings: ViewColumnState;
}

export const initialState: ViewCacheState = {
  branchSettings: null,
};
